import { ElementRef, HostListener, Input, Directive } from '@angular/core';

declare var document: any;

@Directive({
	selector: '[save-state-on-blur]'
})
export class SaveStateOnBlurDirective {
	// 可选：自定义存储键名（默认用固定键）
	@Input() contentStorageKey = 'savedContent';
	@Input() cursorStorageKey = 'savedCursorPosition'; // 保留原光标位置键（兼容旧逻辑）
	@Input() selectionStartKey = 'savedSelectionStart'; // 新增：选中起始位置存储键
	@Input() selectionEndKey = 'savedSelectionEnd';     // 新增：选中结束位置存储键
	@Input() isSelectedKey = 'savedIsSelected';         // 新增：是否有选中内容的标记键

	constructor(private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) { }

	/**
	 * 监听元素失焦事件
	 * 记录：内容 + 光标位置 + 选中范围 + 是否选中
	 */
	@HostListener('blur')
	onBlur(): void {
		const element = this.el.nativeElement;
		const currentContent = element.value;

		// 1. 记录当前内容（原逻辑不变）
		(element as any)[this.contentStorageKey] = currentContent;

		// 2. 获取并记录光标位置 + 选中范围（核心修改）
		const { cursorPosition, selectionStart, selectionEnd, isSelected } = this.getCursorAndSelection(element);

		(element as any)[this.cursorStorageKey] = cursorPosition;       // 原光标位置（兼容旧代码）
		(element as any)[this.selectionStartKey] = selectionStart;     // 选中起始位置
		(element as any)[this.selectionEndKey] = selectionEnd;         // 选中结束位置
		(element as any)[this.isSelectedKey] = isSelected;             // 是否有选中内容（true/false）

		// 可选：控制台打印调试（生产环境可删除）
		console.log(`[SaveStateOnBlur] 已记录 - ` +
			`内容: ${currentContent}, ` +
			`光标位置: ${cursorPosition}, ` +
			`选中范围: [${selectionStart}, ${selectionEnd}], ` +
			`是否选中: ${isSelected}`);
	}

	/**
	 * 获取输入框/文本域的「光标位置 + 选中范围」
	 * @param element 目标元素（input[type="text"] 或 textarea）
	 * @returns 包含光标位置、选中范围、是否选中的对象
	 */
	private getCursorAndSelection(
		element: HTMLInputElement | HTMLTextAreaElement
	): {
		cursorPosition: number;
		selectionStart: number;
		selectionEnd: number;
		isSelected: boolean;
	} {
		const selectionStart = element.selectionStart || 0;
		const selectionEnd = element.selectionEnd || 0;
		return {
			cursorPosition: selectionStart,
			selectionStart,
			selectionEnd,
			isSelected: selectionStart !== selectionEnd
		};
	}

	/**
	 * 可选：暴露公共方法，允许手动触发记录（供其他组件调用）
	 */
	public manualSaveState(): void {
		this.onBlur();
	}
}